import { render, staticRenderFns } from "./IconWideViewCollapse.vue?vue&type=template&id=43d78488"
import script from "./IconWideViewCollapse.vue?vue&type=script&lang=js"
export * from "./IconWideViewCollapse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports